/**
 * Evaluated once, as app.tsx's first import, so it runs before any other app
 * module reads the location or localStorage.activeTab. See bootPopoutLocation.
 */
import { bootPopoutLocation, type PopoutBoot } from './popoutStorageShield';

export const POPOUT_BOOT: PopoutBoot = typeof window === 'undefined' ? { kind: null } : bootPopoutLocation(window);
